import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import FileSaver from "file-saver";
import MeasureUnitHelper from "@Scripts/Infrastructure/MeasureUnitHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "CatalogueProductDetailConfiguration" })
export default class CatalogueProductDetailConfiguration extends Vue {
    public localizer: any = Localizer;
    public measureUnitHelper: any = MeasureUnitHelper;
    public isLoading: boolean = true;
    public isDownloading: boolean = false;

    public product: any = null;
    public productConfigurations: [] = [];

    public isGenerating: boolean = false;
    public zip: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    get measureUnits() {
        return this.$store.getters["measureUnitStore/measureUnits"];
    }

    @Prop() readonly itemCode: string;
    @Prop() readonly itemRevision: string;

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;

        try {
            const response = (await Axios.post(this.routes.Catalogue_GetProductDetailConfigurationData, { itemCode: this.itemCode, itemRevision: this.itemRevision })).data;

            this.product = response.product;
            this.productConfigurations = response.productConfigurations;
        } catch (error) {
            this.product = null;
            this.productConfigurations = [];
        }

        this.isLoading = false;
    }

    public async downloadZip(assetType: string) {
        this.isDownloading = true;
        this.zip = new JSZip();

        let assets: any[] = [];
        let fileExtension: string = assetType === "Ldt" ? ".ldt" : ".ies";

        for (const configuration of this.productConfigurations) {
            for (const asset of (<any>configuration).assets.filter(x => x.fileExtension === fileExtension)) {
                assets.push(asset);
            }
        }

        if (assets.length !== 0) {
            this.isGenerating = true;

            let promises = [];
            let vm = this;

            for (let i = 0; i < assets.length; i++) {
                promises.push(new Promise((resolve, reject) => {
                    let asset = assets[i];
                    if (asset.fileCode) {
                        JSZipUtils.getBinaryContent('/it/media/asset/documents/' + asset.fileCode, function (err, data) {
                            vm.zip.file(asset.assetId + asset.fileExtension, data);
                            resolve(0);
                        });
                    }
                }));
            }

            await Promise.all(promises).then(() => {
                this.generateZip(this.product.orderCode + "_" + assetType);
                GTagHelper.sendEvent("file_download", "product_configuration", "all" + " " + assetType)
            });
        }

        this.isDownloading = false;
    }

    public generateZip(name: string) {
        let vm = this;

        this.zip.generateAsync({ type: "blob" }).then(function (content) {
            FileSaver.saveAs(content, name + ".zip");

            vm.isGenerating = false;
        });
    }

    public setCamelCase(value: string) {
        return value.charAt(0).toLowerCase() + value.slice(1);
    }

    public setAnalytics(assetType: string) {
        GTagHelper.sendEvent("file_download", "product_configuration", assetType)
    }
};